export type ColumnAlignment = "left" | "center" | "right";
export type ColumnVisibility = "always" | "md" | "lg" | "xl";

export interface DashboardColumnConfig {
    label: string;
    field: string;
    width: string;
    align: ColumnAlignment;
    showOn?: ColumnVisibility;
}

// Shared column configuration for both the data table and skeleton
export const dashboardColumns: DashboardColumnConfig[] = [
    { label: "File #", field: "usaFileNumber", width: "145px", align: "center" },
    { label: "Status", field: "orderStatus", width: "100px", align: "center" },
    { label: "Assigned", field: "assignmentActualDate", width: "75px", showOn: "lg", align: "center" },
    { label: "Inspected", field: "inspectionActualDate", width: "75px", showOn: "lg", align: "center" },
    { label: "Due Date", field: "appraiserDueDate", width: "85px", align: "center" },
    { label: "Property", field: "propertyAddressLine1", width: "95px", align: "left" },
    { label: "Borrower", field: "borrowerName", width: "60px", align: "left" },
    { label: "Vendor", field: "appraiserName", width: "60px", align: "left" },
];